import React from "react";

interface AddIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const ClockIcon: React.FC<AddIconProps> = ({
  size = 20,
  color = 'currentColor',
  className,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M18.3332 10C18.3332 14.6 14.5998 18.3334 9.99984 18.3334C5.39984 18.3334 1.6665 14.6 1.6665 10C1.6665 5.40002 5.39984 1.66669 9.99984 1.66669C14.5998 1.66669 18.3332 5.40002 18.3332 10Z"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0919 12.65L10.5086 11.1084C10.0586 10.8417 9.69189 10.2 9.69189 9.67503V6.25836"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ClockIcon;
<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">

</svg>
